import React from "react";
import {useTranslation} from "react-i18next";
// import resumeFile from "../documents/resume.pdf";

const Resume = ({classicHeader, darkTheme}) => {
        const {t} = useTranslation();
        const educationDetails = [
            {
                yearRange: "2013 - 2013",
                title: t('resume.education.title1'),
                place: t('resume.education.place1'),
                desc: t('resume.education.desc1')
            },
            {
                yearRange: "2010 - 2013",
                title: t('resume.education.title2'),
                place: t('resume.education.place2'),
                desc: t('resume.education.desc2')
            },
            {
                yearRange: "2005 - 2009",
                title: t('resume.education.title3'),
                place: t('resume.education.place3'),
                desc: t('resume.education.desc3')
            }
        ];

        const experienceDetails = [
            {
                yearRange: "2022 - 2025",
                title: t('resume.experience.title1'),
                place: t('resume.experience.place1'),
                desc: t('resume.experience.desc1')
            },
            {
                yearRange: "2021 - 2022",
                title: t('resume.experience.title2'),
                place: t('resume.experience.place2'),
                desc: t('resume.experience.desc2')
            },
            {
                yearRange: "2017 - 2019",
                title: t('resume.experience.title3'),
                place: t('resume.experience.place3'),
                desc: t('resume.experience.desc3')
            }
        ];

        const devSkills = [
            {
                name: "Ruby",
                percent: 100,
            },
            {
                name: "Python",
                percent: 70,
            },
            {
                name: "AI Development",
                percent: 90,
            },
            {
                name: "Java",
                percent: 80,
            },
            {
                name: "JavaScript",
                percent: 80,
            },
            {
                name: "C++",
                percent: 60,
            },
            {
                name: t('resume.skills.others'),
                percent: 60,
            },
        ];

        const webSkills = [
            {
                name: "Ruby on Rails",
                percent: 100,
            },
            {
                name: "HTML/CSS",
                percent: 80,
            },
            {
                name: "jQuery",
                percent: 80,
            },
            {
                name: "React JS",
                percent: 70,
            },
            {
                name: t('resume.skills.web_design'),
                percent: 60,
            },
            {
                name: "Bootstrap",
                percent: 90,
            },
        ];

        const otherSkills = [
            {
                name: t('resume.skills.db'),
                percent: 90,
            },
            {
                name: t('resume.skills.os_and_cloud'),
                percent: 70,
            },
            {
                name: t('resume.skills.uml'),
                percent: 60,
            },
            {
                name: t('resume.skills.git'),
                percent: 80,
            },
        ];

        return (
            <section
                id="resume"
                className={"section " + (darkTheme ? "bg-dark-1" : "")}
            >
                <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
                    {/* Heading */}
                    <div className="position-relative d-flex text-center mb-5">
                        <h2
                            className={
                                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
                            }
                        >
                            {t('resume.title1')}
                        </h2>
                        <p
                            className={
                                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                                (darkTheme ? "text-white" : "text-dark")
                            }
                        >
                            {" "}
                            {t('resume.title2')}
                            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"/>
                        </p>
                    </div>
                    {/* Heading end*/}
                    <div className="row gx-5">
                        {/* My Education */}
                        <div className="col-md-6">
                            <h2
                                className={
                                    "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
                                }
                            >
                                {t('resume.education.my_education')}
                            </h2>
                            {educationDetails.length > 0 &&
                                educationDetails.map((value, index) => (
                                    <div
                                        key={index}
                                        className={
                                            "bg-white  rounded p-4 mb-4 " +
                                            (darkTheme ? "bg-dark" : "bg-white border")
                                        }
                                    >
                                        <p className="badge bg-primary text-2 fw-400">
                                            {value.yearRange}
                                        </p>
                                        <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                                            {value.title}
                                        </h3>
                                        <p className={darkTheme ? "text-primary" : "text-success"}>
                                            {value.place}
                                        </p>
                                        <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                                            {value.desc}
                                        </p>
                                    </div>
                                ))}
                        </div>
                        {/* My Experience */}
                        <div className="col-md-6">
                            <h2
                                className={
                                    "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
                                }
                            >
                                {t('resume.experience.my_experience')}
                            </h2>
                            {experienceDetails.length > 0 &&
                                experienceDetails.map((value, index) => (
                                    <div
                                        key={index}
                                        className={
                                            "bg-white  rounded p-4 mb-4 " +
                                            (darkTheme ? "bg-dark" : "bg-white border")
                                        }
                                    >
                                        <p className="badge bg-primary text-2 fw-400">
                                            {value.yearRange}
                                        </p>
                                        <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                                            {value.title}
                                        </h3>
                                        <p className={darkTheme ? "text-primary" : "text-success"}>
                                            {value.place}
                                        </p>
                                        <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                                            {value.desc}
                                        </p>
                                    </div>
                                ))}
                        </div>
                    </div>
                    {/* My Skills */}
                    <h2
                        className={
                            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
                        }
                    >
                        {t('resume.skills.title')}
                    </h2>
                    <h5
                        className={
                            "text-4 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
                        }
                    >
                        {t('resume.skills.title1')}
                    </h5>
                    <div className="row gx-5">
                        {devSkills.length > 0 &&
                            devSkills.map((skill, index) => (
                                <div key={index} className="col-md-6">
                                    <p
                                        className={
                                            " fw-500 text-start mb-2 " +
                                            (darkTheme ? "text-light" : "text-dark")
                                        }
                                    >
                                        {skill.name}{" "}
                                        <span className="float-end">{skill.percent}%</span>
                                    </p>
                                    <div
                                        className={
                                            "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                                        }
                                    >
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{width: skill.percent + "%"}}
                                            aria-valuenow={skill.percent}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        />
                                    </div>
                                </div>
                            ))}
                    </div>
                    <h5
                        className={
                            "text-4 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
                        }
                    >
                        {t('resume.skills.title2')}
                    </h5>
                    <div className="row gx-5">
                        {webSkills.length > 0 &&
                            webSkills.map((skill, index) => (
                                <div key={index} className="col-md-6">
                                    <p
                                        className={
                                            " fw-500 text-start mb-2 " +
                                            (darkTheme ? "text-light" : "text-dark")
                                        }
                                    >
                                        {skill.name}{" "}
                                        <span className="float-end">{skill.percent}%</span>
                                    </p>
                                    <div
                                        className={
                                            "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                                        }
                                    >
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{width: skill.percent + "%"}}
                                            aria-valuenow={skill.percent}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        />
                                    </div>
                                </div>
                            ))}
                    </div>
                    <h5
                        className={
                            "text-4 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
                        }
                    >
                        {t('resume.skills.title3')}
                    </h5>
                    <div className="row gx-5">
                        {otherSkills.length > 0 &&
                            otherSkills.map((skill, index) => (
                                <div key={index} className="col-md-6">
                                    <p
                                        className={
                                            " fw-500 text-start mb-2 " +
                                            (darkTheme ? "text-light" : "text-dark")
                                        }
                                    >
                                        {skill.name}{" "}
                                        <span className="float-end">{skill.percent}%</span>
                                    </p>
                                    <div
                                        className={
                                            "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                                        }
                                    >
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{width: skill.percent + "%"}}
                                            aria-valuenow={skill.percent}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        />
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className="text-center mt-5">
                        <a
                            className="btn btn-outline-secondary rounded-pill shadow-none"
                            href="https://resume.io/r/cUSPJwbWK"
                            target={"_blank"}
                            rel="noreferrer"
                            download
                        >
                            {t('resume.download_cv')}
                            <span className="ms-1">
              <i className="fas fa-download"/>
            </span>
                        </a>
                    </div>
                    <div className="text-center mt-5">
                        <a
                            className="btn btn-outline-secondary rounded-pill shadow-none"
                            href="https://resume.io/r/wVgrsio7k"
                            target={"_blank"}
                            rel="noreferrer"
                            download
                        >
                            {t('resume.download_resume')}
                            <span className="ms-1">
              <i className="fas fa-download"/>
            </span>
                        </a>
                    </div>
                </div>
            </section>
        );
    }
;

export default Resume;
